import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchMeetupsdtlbannersec } from "../services/Meetupsdtlbannersec";
import { API_BASE } from "../api/apiConfig";

const Meetupsdtlaboutsec = () => {
  const { city } = useParams();
  const [meetup, setMeetup] = useState(null);
  const [relatedMeetups, setRelatedMeetups] = useState([]);
  const [loading, setLoading] = useState(true);

  const [activeTab, setActiveTab] = useState('details');

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchMeetupsdtlbannersec(decodeURIComponent(city));

      if (res?.status && res?.data?.length > 0) {
        setMeetup(res.data[0]); // first meetup of city
      }

      setRelatedMeetups(res.related_meetups || []);

      setLoading(false);
    };

    loadBanner();
  }, [city]);

  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!meetup) return <p className="text-center py-10">No meetup found</p>;

  return (
      
      <div className="md:col-span-2">
         {/* About This Meetup */}
      <div className="mb-10 bg-white rounded-xl border border-slate-100 p-6 shadow-sm">
        <h2 className="mb-4 text-2xl font-bold text-slate-800">
          About This Meetup
        </h2>
        <p className="whitespace-pre-line text-slate-600 leading-relaxed">
          {meetup.about.replace(/<[^>]+>/g, '')}
        </p>
      </div>
      {/* Nav Tabs */}
      <div className="w-full">
      {/* Tab list */}
    <div
      role="tablist"
      aria-orientation="horizontal"
      className="items-center justify-center w-full grid grid-cols-4 h-12 bg-slate-100/80 p-1 rounded-xl mb-4"
    >
      <button
        id="tab-details"
        role="tab"
        aria-selected={activeTab === 'details'}
        aria-controls="tabpanel-details"
        className={`px-3 py-1.5 text-sm font-medium rounded-lg focus:outline-none focus:ring-2 focus:ring-ring transition data-[state=active]:text-primary data-[state=active]:bg-white`}
        data-state={activeTab === 'details' ? 'active' : 'inactive'}
        onClick={() => handleTabChange('details')}
      >
        Details
      </button>
      <button
        id="tab-host"
        role="tab"
        aria-selected={activeTab === 'host'}
        aria-controls="tabpanel-host"
        className={`px-3 py-1.5 text-sm font-medium rounded-lg focus:outline-none focus:ring-2 focus:ring-ring transition data-[state=active]:text-primary data-[state=active]:bg-white`}
        data-state={activeTab === 'host' ? 'active' : 'inactive'}
        onClick={() => handleTabChange('host')}
      >
        Host
      </button>
      <button
        id="tab-faqs"
        role="tab"
        aria-selected={activeTab === 'faqs'}
        aria-controls="tabpanel-faqs"
        className={`px-3 py-1.5 text-sm font-medium rounded-lg focus:outline-none focus:ring-2 focus:ring-ring transition data-[state=active]:text-primary data-[state=active]:bg-white`}
        data-state={activeTab === 'faqs' ? 'active' : 'inactive'}
        onClick={() => handleTabChange('faqs')}
      >
        FAQs
      </button>
      {/*<button
        id="tab-reviews"
        role="tab"
        aria-selected={activeTab === 'reviews'}
        aria-controls="tabpanel-reviews"
        className={`px-3 py-1.5 text-sm font-medium rounded-lg focus:outline-none focus:ring-2 focus:ring-ring transition data-[state=active]:text-primary data-[state=active]:bg-white`}
        data-state={activeTab === 'reviews' ? 'active' : 'inactive'}
        onClick={() => handleTabChange('reviews')}
      >
        Reviews
      </button>*/}
    </div>

      {/* Content panels */}
      {activeTab === 'details' && (
        <div
          id="tabpanel-details"
          role="tabpanel"
          aria-labelledby="tab-details"
          className="space-y-8 pt-8"
        >
          {/* What to Expect */}
          <div>
            <h3 className="mb-4 text-xl font-medium text-slate-800">
              What to Expect
            </h3>
            <div className="grid gap-4 md:grid-cols-2">
              {/* Duration */}
              <div className="rounded-lg border border-slate-200 p-4">
                <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-clock h-5 w-5"
                  >
                    <circle cx={12} cy={12} r={10} />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                </div>
                <h4 className="mb-2 font-medium text-slate-800">Duration</h4>
                <p className="text-sm text-slate-600">{meetup.duration}</p>
              </div>
              {/* Difficulty */}
              <div className="rounded-lg border border-slate-200 p-4">
                <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-info h-5 w-5"
                  >
                    <circle cx={12} cy={12} r={10} />
                    <path d="M12 16v-4" />
                    <path d="M12 8h.01" />
                  </svg>
                </div>
                <h4 className="mb-2 font-medium text-slate-800">Difficulty</h4>
                <p className="text-sm text-slate-600">{meetup.difficulty}</p>
              </div>
            </div>
          </div>
          {/* What's Included */}
          <div>
            <h3 className="mb-4 text-xl font-medium text-slate-800">
              What's Included
            </h3>
            <div className="space-y-2">

           {JSON.parse(meetup.included).map((item, index) => (
              <div className="flex items-center gap-2">
                <div className="flex h-6 w-6 items-center justify-center rounded-full bg-green-100 text-green-600">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check h-4 w-4"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                </div>
                <span className="text-slate-700">{item}</span>
              </div>
          ))}

            </div>
          </div>
          {/* What's Not Included */}
          <div>
            <h3 className="mb-4 text-xl font-medium text-slate-800">
              What's Not Included
            </h3>
            <div className="space-y-2">

          {JSON.parse(meetup.notincluded).map((notincludeditem, index) => (
              <div className="flex items-center gap-2">
                <div className="flex h-6 w-6 items-center justify-center rounded-full bg-red-100 text-red-600">
                  <span className="text-sm font-bold">×</span>
                </div>
                <span className="text-slate-700">
                  {notincludeditem}
                </span>
              </div>
          ))}



            </div>
          </div>
          {/* Meeting Point */}
          <div>
            <h3 className="mb-4 text-xl font-medium text-slate-800">
              Meeting Point
            </h3>

        {JSON.parse(meetup.title).map((title, index) => (
            <div className="rounded-lg border border-slate-200 p-4 mt-4">
              <div className="flex items-start gap-3">
                <div className="mt-1 flex h-8 w-8 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-map h-4 w-4"
                  >
                    <path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z" />
                    <path d="M15 5.764v15" />
                    <path d="M9 3.236v15" />
                  </svg>
                </div>
                <div>
                  <p className="font-medium text-slate-800">
                    {JSON.parse(meetup.title)[index]}
                  </p>
                  <p className="mt-1 text-sm text-slate-600">
                    {JSON.parse(meetup.comment)[index]}
                  </p>
                  <a
                    href={JSON.parse(meetup.googlemap)[index]}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-2 inline-flex items-center text-sm text-primary hover:underline"
                  >
                    View on Google Maps
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-arrow-right ml-1 h-3 w-3"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
        ))}


          </div>
          {/* Requirements */}
          <div>
            <h3 className="mb-4 text-xl font-medium text-slate-800">
              Requirements
            </h3>
            <ul className="list-inside list-disc space-y-1 text-slate-700">
              {meetup.requirements.replace(/<[^>]+>/g, '')}
            </ul>
          </div>
          {/* Cancellation Policy */}
          <div>
            <h3 className="mb-4 text-xl font-medium text-slate-800">
              Cancellation Policy
            </h3>
            <p className="text-slate-700">
              {meetup.policy.replace(/<[^>]+>/g, '')}
            </p>
          </div>
          
      {relatedMeetups && relatedMeetups.length > 0 && (
          <div className="mt-16 bg-slate-50 p-6 rounded-xl">
            <h2 className="mb-6 text-2xl font-bold text-slate-800">
              Similar Meetups You Might Like
            </h2>
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {/* Meetup Card */}

          {relatedMeetups.map((item) => (
              <div key={item.id} className="rounded-lg border bg-card text-card-foreground shadow-sm group overflow-hidden border-slate-200 hover:border-primary/30">
                <div className="relative h-40 w-full overflow-hidden">
                  <img
                    alt={item.heading}
                    loading="lazy"
                    decoding="async"
                    className="object-cover transition-transform duration-700 group-hover:scale-110"
                    src={`${API_BASE}/${item.image}`}
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
                  <div className="absolute left-3 top-3 rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-white/90 text-slate-800 hover:bg-primary/80">
                      {item.city}
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="mb-2 font-medium text-slate-800 line-clamp-1">
                      {item.heading}
                  </h3>
                  <div className="mb-3 flex items-center gap-1 text-sm text-slate-500">
                    {/* Calendar Icon */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="lucide lucide-calendar h-4 w-4 text-primary"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <rect x={3} y={4} width={18} height={18} rx={2} />
                      <path d="M8 2v4" />
                      <path d="M16 2v4" />
                      <path d="M3 10h18" />
                    </svg>
                    <span>{item.date}</span>
                  </div>
                  <a
                    href={`/MeetupsDtl/${item.id}`}
                    className="text-primary hover:underline"
                  >
                    View Details
                  </a>
                </div>
              </div>
           ))}

              {/* Repeat other meetup cards as needed */}
            </div>
          </div>
      )}
        </div>
      )}

      {activeTab === 'host' && (
        <div
          id="tabpanel-host"
          role="tabpanel"
          aria-labelledby="tab-host"
          className="pt-8"
        >

      {meetup.local_experts_details && meetup.local_experts_details.length > 0 && (
         <div className="rounded-xl border border-slate-200 p-6 shadow-sm bg-white">
            <div className="flex flex-col items-start gap-6 md:flex-row">
              {/* Host Profile */}
              <div className="flex flex-col items-center">
                {/* Host Image */}
                <div className="relative h-24 w-24 overflow-hidden rounded-full border-4 border-white shadow-md">
                  <img
                    alt={meetup.local_experts_details[0].name}
                    loading="lazy"
                    decoding="async"
                    className="object-cover"
                    src={
                        meetup.local_experts_details?.[0]?.profile_image
                          ? `${API_BASE}/${meetup.local_experts_details[0].profile_image}`
                          : "/member-3.jpg"
                      }
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0
                    }}
                  />
                </div>
                {/* Rating */}
                <div className="mt-3 flex items-center gap-1">
                  {/* Star Icon */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                  </svg>
                  <span className="font-medium">4.8</span>
                  <span className="text-sm text-slate-500">(156)</span>
                </div>
                {/* Hosting Since */}
                <p className="mt-1 text-sm text-slate-500">
                  Hosting since 2020
                </p>
              </div>
              {/* Host Details */}

              <div className="flex-1">
                <h3 className="mb-1 text-xl font-bold text-slate-800">
                  {meetup.local_experts_details[0].name}
                </h3>
                <p className="mb-4 text-slate-600">
                 {meetup.local_experts_details[0].about}
                </p>
                <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border bg-background hover:text-accent-foreground h-10 px-4 py-2 border-primary/30 text-primary hover:bg-primary/10">
                  Contact Host
                </button>
              </div>

            </div>
          </div>
      )}

      
      {relatedMeetups && relatedMeetups.length > 0 && (
          <div className="mt-16 bg-slate-50 p-6 rounded-xl">
            <h2 className="mb-6 text-2xl font-bold text-slate-800">
              Similar Meetups You Might Like
            </h2>
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {/* Meetup Card */}

          {relatedMeetups.map((item) => (
              <div key={item.id} className="rounded-lg border bg-card text-card-foreground shadow-sm group overflow-hidden border-slate-200 hover:border-primary/30">
                <div className="relative h-40 w-full overflow-hidden">
                  <img
                    alt={item.heading}
                    loading="lazy"
                    decoding="async"
                    className="object-cover transition-transform duration-700 group-hover:scale-110"
                    src={`${API_BASE}/${item.image}`}
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
                  <div className="absolute left-3 top-3 rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-white/90 text-slate-800 hover:bg-primary/80">
                      {item.city}
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="mb-2 font-medium text-slate-800 line-clamp-1">
                      {item.heading}
                  </h3>
                  <div className="mb-3 flex items-center gap-1 text-sm text-slate-500">
                    {/* Calendar Icon */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="lucide lucide-calendar h-4 w-4 text-primary"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <rect x={3} y={4} width={18} height={18} rx={2} />
                      <path d="M8 2v4" />
                      <path d="M16 2v4" />
                      <path d="M3 10h18" />
                    </svg>
                    <span>{item.date}</span>
                  </div>
                  <a
                    href={`/MeetupsDtl/${item.id}`}
                    className="text-primary hover:underline"
                  >
                    View Details
                  </a>
                </div>
              </div>
           ))}

              {/* Repeat other meetup cards as needed */}
            </div>
          </div>
      )}
        </div>
      )}

      {activeTab === 'faqs' && (
        <div
          id="tabpanel-faqs"
          role="tabpanel"
          aria-labelledby="tab-faqs"
          className="pt-8"
        >
          <div className="space-y-4">

        {JSON.parse(meetup.question).map((question, index) => (
            <div className="rounded-lg border border-slate-200 p-5 mt-4">
              <h3 className="mb-2 font-medium text-slate-800">
                {JSON.parse(meetup.question)[index]}
              </h3>
              <p className="text-slate-600">
                {JSON.parse(meetup.answer)[index]}
              </p>
            </div>
        ))}

          </div>
          
      {relatedMeetups && relatedMeetups.length > 0 && (
          <div className="mt-16 bg-slate-50 p-6 rounded-xl">
            <h2 className="mb-6 text-2xl font-bold text-slate-800">
              Similar Meetups You Might Like
            </h2>
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {/* Meetup Card */}

          {relatedMeetups.map((item) => (
              <div key={item.id} className="rounded-lg border bg-card text-card-foreground shadow-sm group overflow-hidden border-slate-200 hover:border-primary/30">
                <div className="relative h-40 w-full overflow-hidden">
                  <img
                    alt={item.heading}
                    loading="lazy"
                    decoding="async"
                    className="object-cover transition-transform duration-700 group-hover:scale-110"
                    src={`${API_BASE}/${item.image}`}
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
                  <div className="absolute left-3 top-3 rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-white/90 text-slate-800 hover:bg-primary/80">
                      {item.city}
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="mb-2 font-medium text-slate-800 line-clamp-1">
                      {item.heading}
                  </h3>
                  <div className="mb-3 flex items-center gap-1 text-sm text-slate-500">
                    {/* Calendar Icon */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="lucide lucide-calendar h-4 w-4 text-primary"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <rect x={3} y={4} width={18} height={18} rx={2} />
                      <path d="M8 2v4" />
                      <path d="M16 2v4" />
                      <path d="M3 10h18" />
                    </svg>
                    <span>{item.date}</span>
                  </div>
                  <a
                    href={`/MeetupsDtl/${item.id}`}
                    className="text-primary hover:underline"
                  >
                    View Details
                  </a>
                </div>
              </div>
           ))}

              {/* Repeat other meetup cards as needed */}
            </div>
          </div>
      )}
        </div>
      )}

      {activeTab === 'reviews' && (
        <div
          id="tabpanel-reviews"
          role="tabpanel"
          aria-labelledby="tab-reviews"
          className="pt-8"
        >
         <div className="mb-5">
            <div className="flex items-center gap-2">
              <div className="flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star h-5 w-5 fill-amber-400 text-amber-400"
                >
                  <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star h-5 w-5 fill-amber-400 text-amber-400"
                >
                  <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star h-5 w-5 fill-amber-400 text-amber-400"
                >
                  <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                </svg>
              </div>
              <span className="font-medium">4.8</span>
              <span className="text-slate-500">(156 reviews)</span>
            </div>
          </div>
          <div className="space-y-4">
            <div className="rounded-lg border border-slate-200 p-5">
              <div className="flex items-start justify-between">
                <div className="flex items-start gap-3">
                  <span className="relative flex shrink-0 overflow-hidden rounded-full h-10 w-10 border border-slate-200">
                    <span className="flex h-full w-full items-center justify-center rounded-full bg-muted">
                      R
                    </span>
                  </span>
                  <div>
                    <h4 className="font-medium text-slate-800">Rahul S.</h4>
                    <p className="text-xs text-slate-500">March 15, 2024</p>
                  </div>
                </div>
                <div className="flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400"
                  >
                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400"
                  >
                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400"
                  >
                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                  </svg>
                </div>
              </div>
              <p className="mt-3 text-slate-600">
                One of the highlights of my trip to India. The rapids were
                exciting but manageable, and the scenery was breathtaking.
              </p>
            </div>
            <div className="rounded-lg border border-slate-200 p-5">
              <div className="flex items-start justify-between">
                <div className="flex items-start gap-3">
                  <span className="relative flex shrink-0 overflow-hidden rounded-full h-10 w-10 border border-slate-200">
                    <img
                      className="aspect-square h-full w-full"
                      alt="David M."
                      src="/member-1.jpg"
                    />
                  </span>
                  <div>
                    <h4 className="font-medium text-slate-800">David M.</h4>
                    <p className="text-xs text-slate-500">February 10, 2024</p>
                  </div>
                </div>
                <div className="flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400"
                  >
                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400"
                  >
                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400"
                  >
                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                  </svg>
                </div>
              </div>
              <p className="mt-3 text-slate-600">
                Great adventure! The only reason for 4 stars instead of 5 is
                that the group was slightly too large. Otherwise, fantastic
                experience.
              </p>
            </div>
          </div>
          
      {relatedMeetups && relatedMeetups.length > 0 && (
          <div className="mt-16 bg-slate-50 p-6 rounded-xl">
            <h2 className="mb-6 text-2xl font-bold text-slate-800">
              Similar Meetups You Might Like
            </h2>
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {/* Meetup Card */}

          {relatedMeetups.map((item) => (
              <div key={item.id} className="rounded-lg border bg-card text-card-foreground shadow-sm group overflow-hidden border-slate-200 hover:border-primary/30">
                <div className="relative h-40 w-full overflow-hidden">
                  <img
                    alt={item.heading}
                    loading="lazy"
                    decoding="async"
                    className="object-cover transition-transform duration-700 group-hover:scale-110"
                    src={`${API_BASE}/${item.image}`}
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />
                  <div className="absolute left-3 top-3 rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-white/90 text-slate-800 hover:bg-primary/80">
                      {item.city}
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="mb-2 font-medium text-slate-800 line-clamp-1">
                      {item.heading}
                  </h3>
                  <div className="mb-3 flex items-center gap-1 text-sm text-slate-500">
                    {/* Calendar Icon */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="lucide lucide-calendar h-4 w-4 text-primary"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <rect x={3} y={4} width={18} height={18} rx={2} />
                      <path d="M8 2v4" />
                      <path d="M16 2v4" />
                      <path d="M3 10h18" />
                    </svg>
                    <span>{item.date}</span>
                  </div>
                  <a
                    href={`/MeetupsDtl/${item.id}`}
                    className="text-primary hover:underline"
                  >
                    View Details
                  </a>
                </div>
              </div>
           ))}

              {/* Repeat other meetup cards as needed */}
            </div>
          </div>
      )} 
        </div>
      )}
    </div>
      {/* ./Nav Tabs */}
    </div>
 
  );
};

export default Meetupsdtlaboutsec;
